import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";
import { useLang, lpath } from "@/lib/lang";

export default function NotFound() {
  const { t } = useTranslation();
  const lang = useLang();

  return (
    <>
      <Seo title={`${t("notfound.title")} — Ostelo`} description={t("notfound.desc")} lang={lang} />
      <section className="px-6 py-32 text-left lg:px-10" data-testid="not-found">
        <div className="mx-auto max-w-7xl">
          <p className="font-display text-7xl font-semibold text-ostelo-orange/60">404</p>
          <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-ostelo-deep">{t("notfound.title")}</h1>
          <p className="mt-4 max-w-md text-base text-ostelo-ink/60">{t("notfound.desc")}</p>
          <Link
            to={lpath(lang)}
            data-testid="not-found-home-link"
            className="mt-10 inline-flex items-center gap-2 rounded-lg bg-ostelo-deep px-6 py-3.5 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:scale-[0.98] hover:bg-ostelo-blue"
          >
            <ArrowLeft size={16} />
            {t("common.back_home")}
          </Link>
        </div>
      </section>
    </>
  );
}
